var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BridgeProvider__factory, } from "@textile/eth-storage-bridge";
import { PROVIDER_ID, GAS, DEPOSIT } from "./utils";
function initDeposit(contract, _account) {
    return {
        addDeposit: (amount = DEPOSIT, account = _account) => __awaiter(this, void 0, void 0, function* () {
            if (!account)
                throw new Error(`invalid account id: "${account}"`);
            return contract
                .addDeposit(account, {
                value: amount,
            })
                .then(() => undefined);
        }),
        releaseDeposit: (account = _account) => __awaiter(this, void 0, void 0, function* () {
            return contract.releaseDeposit(account).then(() => undefined);
        }),
        releaseDeposits: () => __awaiter(this, void 0, void 0, function* () {
            return contract.releaseDeposits({ gasLimit: GAS }).then(() => undefined);
        }),
        hasDeposit: (account = _account) => __awaiter(this, void 0, void 0, function* () {
            if (!account)
                throw new Error(`invalid account id: "${account}"`);
            return contract.hasDeposit(account);
        }),
        apiEndpoint: () => __awaiter(this, void 0, void 0, function* () {
            return contract.apiEndpoint();
        }),
    };
}
export function create(account, contractId = PROVIDER_ID) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = BridgeProvider__factory.connect(contractId, account);
        return initDeposit(contract, yield account.getAddress());
    });
}
//# sourceMappingURL=provider.js.map